function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard-Copy",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "download/24x24"
}, React.createElement("path", {
  d: "M11.0001063,13 C11.552391,13 12.0001063,13.4477153 12.0001063,14 C12.0001063,14.5128358 11.6140661,14.9355072 11.1167274,14.9932723 L11.0001063,15 L5.00010627,15 C4.44782152,15 4.00010627,14.5522847 4.00010627,14 C4.00010627,13.4871642 4.38614646,13.0644928 4.88348515,13.0067277 L5.00010627,13 L11.0001063,13 Z M8.00010627,1 C8.55239102,1 9.00010627,1.44771525 9.00010627,2 L9,7.585 L10.2928932,6.29289322 C10.6533772,5.93240926 11.2206082,5.90467972 11.6128994,6.20970461 L11.7071068,6.29289322 C12.0675907,6.65337718 12.0953203,7.22060824 11.7902954,7.61289944 L11.7071068,7.70710678 L8.70710678,10.7071068 C8.34662282,11.0675907 7.77939176,11.0953203 7.38710056,10.7902954 L7.29289322,10.7071068 L4.29289322,7.70710678 C3.90236893,7.31658249 3.90236893,6.68341751 4.29289322,6.29289322 C4.65337718,5.93240926 5.22060824,5.90467972 5.61289944,6.20970461 L5.70710678,6.29289322 L7,7.585 L7.00010627,2 C7.00010627,1.44771525 7.44782152,1 8.00010627,1 Z",
  id: "Combined-Shape"
})));

var SvgIDownload1616 = function SvgIDownload1616(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIDownload1616, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i-download-16-16.462ccd24.svg";
export { ForwardRef as ReactComponent };